import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import AddSettingModal from "../../components/Modal/AddSettingModal";
import Modal from "../../components/Modal/Modal";

import API from "../../tools/API";
import styles from './Options.module.scss';
import { SingleSetting } from '../../tools/interfaces'
import RemoveSetting from "../../components/Modal/RemoveSetting";

const Options = () => {
    const [settings, setSettings] = useState<SingleSetting[]>([]);
    const [page, setPage] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [removeSettingModal, setRemoveSettingModal] = useState<number | boolean>(false);

    useEffect(() => {
        API.getListOfSettings(page, 100).then(res => {
            if (res) setSettings(res.data.data);
        })
    }, [showModal, removeSettingModal])




    return (
        <>
            <div className={styles.options}>
                <div className={styles.btnContainer}>
                    <button
                        className={styles.btnSet}
                        onClick={(e) => {
                            e.preventDefault();
                            setShowModal(true);
                        }
                        }
                    >
                        <div className={styles.addIcon}></div>
                        Dodaj ustawienie
                    </button>
                </div>
                <h2 className={styles.options__header}>
                    Lista ustawień
                </h2>
                <ul className={styles.options__list}>
                    {settings && (
                        settings.map((x, index) => {
                            return (
                                <div className={styles.listElementWrapper} key={x.id}>
                                    <Link
                                        to={`/opcja/${x.id}`}
                                        className={styles.options__link}
                                    >
                                        <li className={styles.options__listElement}>

                                            <span className={styles.indexNr}>{index + 1}. </span>{x.name}

                                        </li>
                                    </Link>
                                    <div
                                        className={styles.deleteBtn}
                                        onClick={
                                            () => {
                                                setRemoveSettingModal(x.id);
                                            }
                                        }
                                    >
                                    </div>
                                </div>
                            )
                        })
                    )}
                </ul>
                {showModal &&
                    <Modal openModal={setShowModal}>
                        <AddSettingModal openModal={setShowModal} />
                    </Modal>
                }
                {removeSettingModal &&
                    <Modal openModal={setRemoveSettingModal}>
                        <RemoveSetting id={removeSettingModal} setSettings={setSettings} openModal={setRemoveSettingModal} />
                    </Modal>
                }
            </div>
        </>
    )
}

export default Options;